import axios from "axios";
import { config } from ".";

// A new instance of axios
const instance = axios.create({
  baseURL: config.restapi_endpoint,
});

export default class RESTAPI {
  /**
   * Getting data about NFTs from REST API
   *
   * @param {string} address - Address of wallet
   * @returns {object}
   */
  static async getDataAboutNFTs(address) {
    try {
      const { data } = await instance.get(`nft/check/${address}`);
      return data;
    } catch ({ message }) {
      return { status: "error", message };
    }
  }

  /**
   * Send request to RESTAPI with wallet address data
   * 
   * @param {string} address 
   */
  static async connectWallet(address) {
    try {
      await instance.post(`wallet/connect/${address}`);
    } catch ({ message }) {
      console.log({ status: "error", message });
    }
  }
}
